import { render, staticRenderFns } from "./Frentistas.vue?vue&type=template&id=a5fc5022&"
import script from "./Frentistas.vue?vue&type=script&lang=js&"
export * from "./Frentistas.vue?vue&type=script&lang=js&"
import style0 from "./Frentistas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports